import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import {
  IFunnelResponse,
  IProtectModeResponse,
  IPermissionStat,
  IErrorsResponse,
  ICallsResponse,
  ILocationResponse,
  ISafetyAlertsResponse,
  IRealtimeStatusResponse,
  IHelpSupportResponse,
} from '~/utils/interface/analytics';

const urlApiAnalytics = {
  funnel: 'analytics/funnel',
  protectMode: 'analytics/protect-mode',
  permissions: 'analytics/permissions',
  errors: 'analytics/errors',
  calls: 'analytics/calls',
  location: 'analytics/location',
  safetyAlerts: 'analytics/safety-alerts',
  realtimeStatus: 'analytics/realtime-status',
  helpSupport: 'analytics/help-support',
  storageModes: 'analytics/storage-modes',
};

const analyticsApi = {
  // Households per storage mode (SERVER / LOCAL).
  getStorageModes() {
    return axiosClient.get<IBaseResponse<{ storageMode: string; households: number }[]>>(
      urlApiAnalytics.storageModes
    );
  },

  getFunnel(storageMode?: string) {
    return axiosClient.get<IBaseResponse<IFunnelResponse>>(urlApiAnalytics.funnel, {
      params: storageMode ? { storageMode } : undefined,
    });
  },

  getProtectMode(storageMode?: string) {
    return axiosClient.get<IBaseResponse<IProtectModeResponse>>(urlApiAnalytics.protectMode, {
      params: storageMode ? { storageMode } : undefined,
    });
  },

  getPermissions(storageMode?: string) {
    return axiosClient.get<IBaseResponse<IPermissionStat[]>>(urlApiAnalytics.permissions, {
      params: storageMode ? { storageMode } : undefined,
    });
  },

  getErrors(storageMode?: string) {
    return axiosClient.get<IBaseResponse<IErrorsResponse>>(urlApiAnalytics.errors, {
      params: storageMode ? { storageMode } : undefined,
    });
  },

  getCalls(storageMode?: string) {
    return axiosClient.get<IBaseResponse<ICallsResponse>>(urlApiAnalytics.calls, {
      params: storageMode ? { storageMode } : undefined,
    });
  },

  getLocation(storageMode?: string) {
    return axiosClient.get<IBaseResponse<ILocationResponse>>(urlApiAnalytics.location, {
      params: storageMode ? { storageMode } : undefined,
    });
  },

  getSafetyAlerts(storageMode?: string) {
    return axiosClient.get<IBaseResponse<ISafetyAlertsResponse>>(urlApiAnalytics.safetyAlerts, {
      params: storageMode ? { storageMode } : undefined,
    });
  },

  getRealtimeStatus(storageMode?: string) {
    return axiosClient.get<IBaseResponse<IRealtimeStatusResponse>>(urlApiAnalytics.realtimeStatus, {
      params: storageMode ? { storageMode } : undefined,
    });
  },

  getHelpSupport(storageMode?: string) {
    return axiosClient.get<IBaseResponse<IHelpSupportResponse>>(urlApiAnalytics.helpSupport, {
      params: storageMode ? { storageMode } : undefined,
    });
  },
};

export default analyticsApi;
